import { ProspectActionKind } from "@prisma/client";
import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import { ProspectActionKindOption, ProspectActionRow } from "@/app/types/prospect/ProspectAction";

const PROSPECT_ACTION_LABEL_KEYS: Record<ProspectActionKind, TKey> = {
  [ProspectActionKind.PROFILE_VISITED]: TKey.PROSPECT_ACTION_PROFILE_VISITED,
  [ProspectActionKind.POST_COMMENTED]: TKey.PROSPECT_ACTION_POST_COMMENTED,
  [ProspectActionKind.CONNECTION_SENT]: TKey.PROSPECT_ACTION_CONNECTION_SENT,
  [ProspectActionKind.CONNECTION_ACCEPTED]: TKey.PROSPECT_ACTION_CONNECTION_ACCEPTED,
  [ProspectActionKind.MESSAGE_SENT]: TKey.PROSPECT_ACTION_MESSAGE_SENT,
  [ProspectActionKind.FOLLOW_UP_SENT]: TKey.PROSPECT_ACTION_FOLLOW_UP_SENT,
  [ProspectActionKind.REPLY_RECEIVED]: TKey.PROSPECT_ACTION_REPLY_RECEIVED,
  [ProspectActionKind.EMAIL_SENT]: TKey.PROSPECT_ACTION_EMAIL_SENT,
  [ProspectActionKind.CALL_MADE]: TKey.PROSPECT_ACTION_CALL_MADE,
  [ProspectActionKind.CALL_BOOKED]: TKey.PROSPECT_ACTION_CALL_BOOKED,
  [ProspectActionKind.CALL_DONE]: TKey.PROSPECT_ACTION_CALL_DONE,
  [ProspectActionKind.CUSTOM]: TKey.PROSPECT_ACTION_CUSTOM,
};

export const PROSPECT_ACTION_KINDS: ProspectActionKind[] = [
  ProspectActionKind.PROFILE_VISITED,
  ProspectActionKind.POST_COMMENTED,
  ProspectActionKind.CONNECTION_SENT,
  ProspectActionKind.MESSAGE_SENT,
  ProspectActionKind.FOLLOW_UP_SENT,
  ProspectActionKind.EMAIL_SENT,
  ProspectActionKind.CALL_BOOKED,
];

export function prospectActionKindLabel(kind: ProspectActionKind, t: TFn): string {
  return String(t(PROSPECT_ACTION_LABEL_KEYS[kind]));
}

export function prospectActionKindOptions(t: TFn): ProspectActionKindOption[] {
  return PROSPECT_ACTION_KINDS.map((kind) => ({
    kind,
    label: prospectActionKindLabel(kind, t),
  }));
}

export function prospectActionLabel(action: ProspectActionRow, t: TFn): string {
  if (action.kind === ProspectActionKind.CUSTOM) {
    return action.type?.label ?? prospectActionKindLabel(ProspectActionKind.CUSTOM, t);
  }
  return prospectActionKindLabel(action.kind, t);
}

export function lastProspectAction(actions?: ProspectActionRow[]): ProspectActionRow | null {
  return actions && actions.length > 0 ? actions[0] : null;
}

export function toInputDate(date: Date): string {
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${date.getUTCFullYear()}-${month}-${day}`;
}

export function todayInputDate(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}
